import { api, createQueryHandler } from './base';

export const tableApi = api.injectEndpoints({
  endpoints: (builder) => ({
    refundTable: builder.mutation({
      query: createQueryHandler('/v1/admin/table/:tableId/refund', 'POST'),
      invalidatesTags: ['Table'],
    }),
    recoverTable: builder.mutation({
      query: createQueryHandler('/v1/admin/table/:tableId/recover', 'POST'),
      invalidatesTags: ['Table'],
    }),
  }),
});

export const { useRefundTableMutation, useRecoverTableMutation } = tableApi;
